export function LoadingState({ rows = 5 }: { rows?: number }) {
  return (
    <div className="loading-state" aria-label="Загрузка">
      {Array.from({ length: rows }, (_, index) => (
        <span key={index} style={{ "--row": index } as React.CSSProperties} />
      ))}
    </div>
  );
}
